import Cookies from 'js-cookie'

const SESSION_ID_KEY = import.meta.env.VITE_SESSION_ID_KEY || 'sessionid'
interface SessionManager {
  readonly isEmpty: () => boolean
  readonly get: () => string | undefined
  readonly remove: () => void
}

const SessionUtil: SessionManager = {
  isEmpty: (): boolean => {
    return !Cookies.get(SESSION_ID_KEY)
  },
  get: (): string | undefined => {
    return Cookies.get(SESSION_ID_KEY)
  },
  remove: () => {
    Cookies.remove(SESSION_ID_KEY, { path: '/' })
  }
}

export default SessionUtil
